<template>
  <div>
    <v-container v-if="trips">
      <v-row>
        <h2 class="pb-4 pt-2">Historie für {{ prettyVehicleName(vehicle) }}</h2>
      </v-row>
      <v-row>
        <v-expansion-panels v-if="trips" v-model="openPanel">
          <Trip :route="item" :show-vehicle="false" :panel-value="String(item.id)" v-for="item in trips" v-bind:key="item.id" />
        </v-expansion-panels>
      </v-row>
    </v-container>
    <v-container v-else-if="err">
      <v-row>
        <v-col cols="12" class="flex">
          <h3>Fahrzeug {{ vehicle }} nicht gefunden (#{{ err.response.status }})</h3>
        </v-col>
      </v-row>
    </v-container>
    <LoadingIndicator v-else/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LoadingIndicator from '@/components/LoadingIndicator.vue'
import OpenPanelMixin from '@/mixins/OpenPanelMixin'
import SearchRangeMixin from '@/mixins/SearchRangeMixin'
import TitleMixin from '@/mixins/TitleMixin'
import Trip from '@/components/Trip.vue'
import VehicleMixin from '@/mixins/VehicleMixin'

export default {
  name: 'VehicleHistory',
  mixins: [OpenPanelMixin, SearchRangeMixin, VehicleMixin, TitleMixin],
  props: ['vehicle'],

  components: {
    LoadingIndicator,
    Trip,
  },

  computed: {
    panelStorageKey: function() {
      return this.vehicle ? `bahnomat.openDay.vehicle.${this.vehicle}` : null;
    },

    ...mapState({
      searchRange: state => state.search.range,

      title: function() {
        if (this.trips) {
          return `${this.prettyVehicleName(this.vehicle)} - ${import.meta.env.VITE_NAME}`;
        }

        return import.meta.env.VITE_NAME;
      },
    }),
  },

  data: () => ({
    err: null,
    trips: null,
  }),

  methods: {
    getVehicleHistory: function() {
      this.trips = null;
      this.err = null;

      if (this.vehicle) {
        this.$log.info(`Retrieving trip history for ${this.vehicle}`);

        this.$api
          .get(`/vehicle/${this.vehicle}/history${this.searchRangeToQuery(this.searchRange)}`)
          .then(response => {
            this.trips = response.data.history;
            this.restoreOpenPanel((this.trips || []).map(item => String(item.id)));
          })
          .catch(err => {
            this.err = err;
          });
      }
    }
  },

  mounted: function () {
    this.getVehicleHistory()
  },

  watch: {
    searchRange: function () {
      this.getVehicleHistory()
    },

    vehicle: function () {
      this.getVehicleHistory()
    }
  },
};
</script>
